module.exports = __webpack_public_path__ + "img/jdm2.4c635390.jpg";